module.exports = __webpack_public_path__ + "img/icon-liquid-gray.ba159183.svg";